import { useQuery } from "@apollo/client/react";
import { Select } from "@nulogy/components";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import { GetAllCustomWorkOrderFields } from "hooks/apollo/customWorkOrderField/customWorkOrderField.gql";
import memoizeOne from "memoize-one";
import React from "react";
import FilterLabel from "./FilterLabel";

const memoizedCustomWorkOrderFields = memoizeOne(buildCustomWorkOrderFieldOptions);

function buildCustomWorkOrderFieldOptions(customWorkOrderFields) {
  return customWorkOrderFields.map(({ name, color }) => ({
    color,
    label: name,
    value: name,
  }));
}

export default function CustomWorkOrderFieldSelector({ onChange, selectedCustomWorkOrderFields }) {
  const applicationContext = useApplicationContext();
  const { data, refetch: refetchCustomWorkOrderFields } = useQuery(GetAllCustomWorkOrderFields);
  const customWorkOrderFields = data?.customWorkOrderFields || [];

  const {
    site: { customWorkOrderField1Label },
  } = applicationContext;
  const customWorkOrderFieldFilterOptions = memoizedCustomWorkOrderFields(customWorkOrderFields);

  return (
    <>
      <FilterLabel value={customWorkOrderField1Label} />
      <Select
        className="spec-custom-work-order-field-filter-multiselect"
        closeMenuOnSelect={false}
        maxHeight="250"
        multiselect
        onChange={onChange}
        onMenuOpen={refetchCustomWorkOrderFields}
        options={customWorkOrderFieldFilterOptions}
        placeholder="Select..."
        value={selectedCustomWorkOrderFields}
      />
    </>
  );
}
